export default "__VITE_ASSET__Vo8liOuq__"